import { type MultiLessonFlags } from "#/components/exam-results/types";
import { type SingleStudentExamResult } from "#/services/rest/gwt/exam-results/views/type-2/single-user.types";
import styles from "./styles.module.scss";

const MultiLessonCard = ({
  correctNo,
  mark,
  incorrectNo,
  noAnswerNo,
  itemName
}: SingleStudentExamResult & { flags: MultiLessonFlags }) => {
  return (
    <div className={styles["multiLessonCard"]}>
      <div className={styles["multiLessonCard__header"]}>
        <h2 className={styles["multiLessonCard__header-title"]}>{itemName}</h2>
      </div>
      <div className={styles["multiLessonCard__info"]}>
        <span>درصد:</span>
        <span dir="ltr">{mark} %</span>
      </div>
      <div className={styles["multiLessonCard__stats"]}>
        <div className={styles["multiLessonCard__stats--correct"]}>
          <span>درست:</span>&nbsp;
          <span>{correctNo}</span>
        </div>
        <div className={styles["multiLessonCard__stats-separator"]} />
        <div className={styles["multiLessonCard__stats--wrong"]}>
          <span>غلط:</span>&nbsp;
          <span>{incorrectNo}</span>
        </div>
        <div className={styles["multiLessonCard__stats-separator"]} />
        <div className={styles["multiLessonCard__stats--unchecked"]}>
          <span>نزده:</span>&nbsp;
          <span>{noAnswerNo}</span>
        </div>
      </div>
    </div>
  );
};

export default MultiLessonCard;
